<template>
     <PageFull header="Все операции" type="white" :fullwidth="true" :nopadding="false">
        <template v-slot:body>
            <div class="w-full p-0">  
                <OperationsList v-if='ops && ops.length > 0' 
                    :operations="ops" :totalRecords="totalRecords" :loading="loading"
                    @onFilter="setFilter" 
                    @onPageChange="setParams" 
                    :defaultParams="lazyParams"/>
                <Skeleton height="2rem" v-else />
            </div>
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import PageFull from '@/components/public/page.vue'
import OperationsList from '@/components/admin/operation/list.vue'

export default {
    data() {
        return {
            account_id: null,
            ops: [],
            loading: false,
            lazyParams: {
                first: 0,
                rows: 20,
                sort: null,
                sortField: null,
                sortOrder: null,
                filters: {},
            },
            totalRecords: 0,
        }
    },
    components: {
        PageFull,
        OperationsList
    },
    methods: {
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.loadTrans();
        },
        setParams(params) {
            this.lazyParams = params
            this.loadTrans()
        },
        async loadTrans() {
            this.loading = true
            try {
                window.scrollTo({ top: 0, behavior: 'smooth' })
                const ops = await this.connect.GetAdminOperationList(this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters, this.lazyParams.sort).then(res => res)
                if (ops.result && ops.data) {
                    if (ops.result && ops.data.length > 0) this.ops = ops.data
                    else this.ops = []
                }
                this.totalRecords = (ops.total) ? ops.total : 0
            } catch (e) {
                console.log(e)
            }
            this.loading = false
        },
        get_format_amount(value, currency) {
            if(!value) return 0
            return this.helper.format_amount(value, currency)
        },
        get_short_id(value){
            return this.helper.get_short_id(value)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        const operation_id = (this.$route.query.operation_id) ? this.$route.query.operation_id : null
        if(operation_id) this.lazyParams.filters._id = {value: operation_id, matchMode: 'contains'}

        try{
            await this.loadTrans()
        } catch (e) {
            console.log(e)
        }
    },
    
}
</script>